module.exports = __webpack_public_path__ + "static/media/cert-gli-white.badcd52e.svg";